import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { PublicViewsComponent } from './public-views.component';
import { RouterModule } from '@angular/router';
import { PublicViewsRoutes } from './public-views.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PublicViewsComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    PublicViewsRoutes,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    PublicViewsComponent
  ]
})
export class PublicViewsModule { }



// WEBPACK FOOTER //
// ./src/app/public-views/public-views.module.ts